module.exports = __webpack_public_path__ + "static/media/template1_preview.79817ac5.PNG";